module.exports = __webpack_public_path__ + "static/media/growbag_shop3.e54c8a85.webp";